<template>
    <div class="w-100">
        <div class="page-layout blank contacts-manage">
            <div class="pb-15 pr-3 pl-3">
                <div class="d-flex flex-wrap justify-content-between align-items-center py-2">
                    <div class="breadcrumbnew">
                        <span><router-link to="/surveyform/listview" class="text-white pl-2 text-line">Survey Forms</router-link></span>
                        <a>View Survey Forms</a>
                    </div>
                    <div class="d-flex align-items-center pr-4 dis-none-ms mb-1" v-if="active_tab == 'view_forms'">
                        <!-- <div @click="OverAllRatingPopupModal" class="overall-rating fs-14 text-white d-flex align-items-center pointer" >Overall Rating <i class="icon icon-star ml-1 text-white"></i></div> -->
                        <button class="btn btn-default-blue ml-3" style="height: 3.3rem; line-height: 25px !important;" @click="sendSurveyForm">Send</button>
                        <!-- <button class="btn btn-default-blue ml-3" style="height: 3.3rem; line-height: 25px !important;">Duplicate</button> -->
                    </div>
                </div>
                <div class="">
                    <div class="d-flex align-items-start flex-wrap justify-content-between">
                        
                        <!-- <div class="d-flex align-items-center">
                            <div class='slant-tabs' :class="{'activeTab':active_tab == 'view_forms','new-blue':active_tab == 'view_forms'}" @click="switchTabs('view_forms')">
                                <span class="text-capitalize">View Forms</span>
                            </div>
                            <div class="slant-tabs ml-2" :class="{'activeTab':active_tab == 'responses','new-blue':active_tab == 'responses'}" @click="switchTabs('responses')">
                                <span class="text-capitalize">Responses</span>
                            </div>
                        </div> -->
                        <div class="tabs tabs-style-shape">
                            <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                                <defs>
                                    <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                                </defs>
                            </svg>
                            <nav>
                                <ul class="ml-0">
                                    <li :class="{'tab-current':active_tab == 'view_forms'}">
                                        <a href="javascript:;" @click="switchTabs('view_forms')" style="text-decoration: none !important;">
                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                            <span>View Forms</span>
                                        </a>
                                    </li>
                                    <li :class="{'tab-current':active_tab == 'responses'}">
                                        <a href="javascript:;" @click="switchTabs('responses')" style="text-decoration: none !important;">
                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                            <span style="border-radius: 30px 0 0 0;">Responses</span>
                                        </a>
                                    </li>
                                    <!-- For styling we need this tag  -->
                                    <li style="width: 0px !important;flex: 0 !important;">
                                        <a href="#section-shape-3" style="margin: 0">
                                            <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="d-flex align-items-center pr-4 dis-none" v-if="active_tab == 'view_forms'">
                            <!-- <div @click="OverAllRatingPopupModal" class="overall-rating fs-14 text-white d-flex align-items-center pointer" >Overall Rating <i class="icon icon-star ml-1 text-white"></i></div> -->
                            <button class="btn btn-default-blue ml-3" style="height: 3.3rem; line-height: 25px !important;" @click="sendSurveyForm">Send</button>
                            <!-- <button class="btn btn-default-blue ml-3" style="height: 3.3rem; line-height: 25px !important;">Duplicate</button> -->
                        </div>
                    </div>
                    <div class="">
                        <survey-view-forms v-if="active_tab == 'view_forms'"></survey-view-forms>
                        <survey-responses v-if="active_tab == 'responses'"></survey-responses>
                    </div>
                    <over-all-rating-popup @hide-overall-rating-popup="hideOverAllPopup" v-if="overall_rating_popup" modal_name="Overall_Rating_Popup"></over-all-rating-popup>
                    <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
                    <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
                    <send-surveys-info @hide-send-survey-info="hideSendSurveyInfo" :form_id="form_id" modal_name="Send_Surveys_Info" v-if="send_surveys_info"></send-surveys-info>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import survey_forms from '../mixins/survey_forms';
const SurveyViewForms = () => import("./SurveyViewForms");
import { SweetModal } from 'sweet-modal-vue';
const SendSurveysInfo = () => import("./SendSurveysInfo");
const SurveyResponses = () => import("./SurveyResponses");
const OverAllRatingPopup = () => import('./OverAllRatingPopup');
export default {
    mixins: [survey_forms],
    components: {
        SurveyViewForms,
        SurveyResponses,
        OverAllRatingPopup,
        SweetModal,
        SendSurveysInfo
    },
    data() {
        return {
            overall_rating_popup: false,
            active_tab: 'view_forms',
            success_msg: '',
            warning_msg: '',
            send_surveys_info: false,
            form_id: ''
        }
    },
    methods: {
        hideSendSurveyInfo(){
            this.send_surveys_info = false
        },
        switchTabs(active_tab) {
            if (active_tab == 'view_forms') {
                this.active_tab = 'view_forms'
            } else if(active_tab == 'responses') {
                this.active_tab = 'responses'
            }
        },
        sendSurveyForm(){
            this.form_id = this.$route.params.id;
            this.send_surveys_info = true
            setTimeout(() =>{
                this.$modal.show("Send_Surveys_Info")
            },500)
        },
        OverAllRatingPopupModal(){
            this.overall_rating_popup = true
            setTimeout(() => {
                this.$modal.show("Overall_Rating_Popup")
            }, 500)
        },
        hideOverAllPopup(){
            this.overall_rating_popup = false
        },

    },
    mounted() {
    },
    computed: {

    },
    created() {

    }
}
</script>

<style scoped>
    .overall-rating {
        padding: 4px 5.2px 3.5px 6px;
        background-color: #ff9a35;
    }
    @media only screen and (max-width: 534px) {
        .dis-none{
            display: none !important;
        }
    }
    @media only screen and (min-width: 535px) {
        .dis-none-ms{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SurveyForms/ViewSurveyForms.vue